import React, { useRef } from 'react';

import { CarouselArrow } from '../../components/CarouselArrow/CarouselArrow';
import { CarouselTrack } from '../../components/Carousel/CarouselTrack';
import { ProductCard } from './ProductCard';
import type { Athlete } from './athletes';

type ProductsPanelProps = {
    athlete: Athlete;
};

const GAP = 8;

export function ProductsPanel({ athlete }: ProductsPanelProps) {
    const { firstName } = athlete;
    const trackRef = useRef<HTMLDivElement>(null);

    const scrollByPage = (direction: 1 | -1) => {
        const track = trackRef.current;
        if (!track) { return; }
        track.scrollBy({ left: direction * (track.clientWidth + GAP), behavior: 'smooth' });
    };

    return (
        <div className="products-panel">
            <div className="products-panel__top">
                <div className="products-panel__label faves-eyebrow">{firstName}&apos;s faves</div>
                <div className="products-panel__nav">
                    <CarouselArrow
                        direction="prev"
                        ariaLabel="Previous products"
                        onClick={() => scrollByPage(-1)}
                        size="compact"
                    />
                    <CarouselArrow
                        direction="next"
                        ariaLabel="Next products"
                        onClick={() => scrollByPage(1)}
                        size="compact"
                    />
                </div>
            </div>
            <CarouselTrack ref={trackRef} className="products-panel__cards">
                {athlete.products.map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </CarouselTrack>
        </div>
    );
}
